import React from "react";
import { Table } from "react-bootstrap";
function LatestEntryFormTable({ tableData }) {

    return (
        <>
            <Table striped hover>
                <thead>
                    <tr>
                        <th>
                            No
                            {/* <img
                                src="../images/png/arrows.png"
                                width={7}
                                alt=""
                            /> */}
                        </th>
                        <th>
                            Company Name

                        </th>
                        <th>
                            Company Motto

                        </th>
                        <th style={{ width: "100px" }} className="text-center">
                            Logo
                        </th>
                        <th style={{ width: "200px" }} className="text-center">
                            Watermark
                        </th>
                        <th>
                            Category

                        </th>
                        <th>
                            Template

                        </th>
                    </tr>
                </thead>
                <tbody>
                    {/* Map through data to render table rows */}
                    {tableData &&
                        tableData.length > 0 &&
                        tableData.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.companyName}</td>
                                <td>{item?.companyMotto}</td>
                                {/* <td style={{ width: "100px" }}>
                                    <div className="d-flex justify-content-center">
                                        <img
                                            src={Url + item.companyLogo}
                                            width={29}
                                            height={29}
                                            alt=""
                                        />
                                    </div>
                                </td> */}
                                <td>{item.companyLogo}</td>
                                {/* <td style={{ width: "200px" }}>
                                    <div className="d-flex justify-content-center">
                                        <img
                                            src={Url + item.watermark}
                                            width={29}
                                            height={29}
                                            alt=""
                                        />
                                    </div>
                                </td> */}
                                <td>{item?.watermark || ''}</td>
                                <td>{item?.categoryId?.name}</td>
                                <td>{item?.templateId?.name}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </>
    );
}

export default LatestEntryFormTable;
